import { RadioButton } from "Components/Form/RadioButton";
import { getOptions } from "Components/Form/RadioButton/radioButtonUtils";

import Popover from "@storeblocks/popover";
import { PaddedSurface } from "App/global-style";
import { NumericInput } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { VALUE_TYPE } from "Components/NumberValue";
import { TextManager } from "Components/TextContext";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { BoatProductIntroFormValues } from "./boatProductIntroInterfaces";

interface Props {
  formProps: FormikProps<Partial<BoatProductIntroFormValues>>;
  texts: any;
  lang: TextLanguage;
}

export const CommonFormElements = ({
  formProps,
  texts,
  lang,
}: Props): React.ReactElement => {
  const { getText } = TextManager;
  return (
    <PaddedSurface>
      <NumericInput
        id="coverageAmount"
        name="coverageAmount"
        label={getText("boatform.label.coverageamount")}
        error={getError("coverageAmount", formProps)}
        suffix={VALUE_TYPE.NOK}
        inputMode={InputMode.NUMERIC}
        large
        inputProps={{ maxLength: 20 }}
        labelPopover={
          <Popover>{getText("boatform.hint.coverageamount")}</Popover>
        }
      />
      <RadioButton
        name="numberOfYearsAsOwner"
        id="numberOfYearsAsOwner"
        label={getText("boatform.label.numberofyearsasowner")}
        options={getOptions(texts.numberOfYearsAsOwner, lang)}
        direction="vertical"
        error={getError("numberOfYearsAsOwner", formProps)}
        labelPopoverProps={{
          children: <div>{getText("boatform.hint.numberofyearsasowner")}</div>,
        }}
      />
    </PaddedSurface>
  );
};
